import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class TrainingProgramApiService extends ApiService {
  static async getPaginated(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('training-programs', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  static async getAll(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('training-programs', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getDetails(id: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`training-programs/${id}`)
      .then((response: AxiosResponse) => response.data)
  }

  static async create(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('training-programs', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async update(trainingProgramId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`training-programs/${trainingProgramId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async delete(trainingProgramId: string): Promise<AxiosResponse> {
    return this.axios.delete(`training-programs/${trainingProgramId}`)
  }

  static async startProgram(trainingProgramId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`training-programs/${trainingProgramId}/start`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getAllInstances(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('training-program-instances', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getInstance(instanceId: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`training-program-instances/${instanceId}`)
      .then((response: AxiosResponse) => response.data)
  }

  static async updateInstance(instanceId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`training-program-instances/${instanceId}`, data)
      .then((response: AxiosResponse) => response.data)
  }

  static async deleteInstance(trainingProgramInstanceId: string, mode: string): Promise<AxiosResponse> {
    return this.axios.delete(`training-program-instances/${trainingProgramInstanceId}`, {
      data: {
        mode: mode
      }
    }).then((response: AxiosResponse) => response.data)
  }
}
